var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "activities-listing-mass-assign",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        closeOnClickOverlay: false,
        title: _vm.$t.__(
          "activities.listing.massActions.ActivitiesListingMassAssign.assign_activities_title"
        ),
        primaryAction: {
          label: _vm.$t.__("common.actions.confirm"),
          disabled: _vm.isConfirmButtonDisabled,
          action: function() {
            return _vm.confirmMassAssign()
          },
          loading: _vm.isSubmitting
        },
        secondaryActions: [
          {
            label: _vm.$t.__("common.actions.cancel"),
            disabled: _vm.isSubmitting,
            action: function() {
              return _vm.$emit("close")
            }
          }
        ]
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      [
        _vm.isPhonecallSelected
          ? _c("CompassAlert", {
              staticClass: "activities-listing-mass-assign-alert",
              attrs: {
                type: "informative",
                description: _vm.$t.__(
                  "activities.listing.massActions.ActivitiesListingMassAssign.alert_message_phonecall_selected"
                ),
                showClose: false
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "typographies-paragraph-medium-semibold" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t.__("common.labels.several_staff")) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "CompassSelect",
          {
            staticClass: "activities-listing-mass-assign-select",
            attrs: {
              placeholder: _vm.$t.__(
                "activities.listing.massActions.ActivitiesListingMassAssign.assign_staff_placeholder"
              ),
              multiple: "",
              filterable: "",
              menuClass: "activities-listing-mass-assign-select-menu"
            },
            model: {
              value: _vm.selectedStaff,
              callback: function($$v) {
                _vm.selectedStaff = $$v
              },
              expression: "selectedStaff"
            }
          },
          _vm._l(_vm.metas.authors, function(staff) {
            return _c("CompassDropdownSelectOption", {
              key: staff.id,
              attrs: {
                label: staff.firstname + " " + staff.lastname,
                value: staff.id,
                type: "avatar",
                avatar: _vm.getAvatarObject(
                  staff.firstname,
                  staff.lastname,
                  staff.avatar
                )
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass:
              "typographies-paragraph-small-regular activities-listing-mass-assign-info-text-color"
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t.__(
                    "activities.listing.massActions.ActivitiesListingMassAssign.assign_activities_info"
                  )
                ) +
                "\n        "
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "CompassFormItem",
          {
            staticClass: "activities-listing-mass-assign-radio-group",
            attrs: {
              label: _vm.$t.__(
                "activities.listing.massActions.ActivitiesListingMassAssign.radioGroup_label_assign_type"
              )
            }
          },
          [
            _c(
              "CompassRadioGroup",
              {
                model: {
                  value: _vm.assignType,
                  callback: function($$v) {
                    _vm.assignType = $$v
                  },
                  expression: "assignType"
                }
              },
              [
                _c("CompassRadio", {
                  attrs: {
                    label: _vm.$t.__(
                      "activities.listing.massActions.ActivitiesListingMassAssign.radio_label_replace_staff"
                    ),
                    modelValue: "replace_assignees"
                  }
                }),
                _vm._v(" "),
                _c("CompassRadio", {
                  attrs: {
                    label: _vm.$t.__(
                      "activities.listing.massActions.ActivitiesListingMassAssign.radio_label_add_staff"
                    ),
                    modelValue: "add_assignees"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }